
import { useState } from 'react';

const useVisibility = (initialState = {}) => {
  const [hiddenSections, setHiddenSections] = useState(initialState);

  const hideSection = (key) => {
    setHiddenSections((prev) => ({ ...prev, [key]: true }));
  };

  const showSection = (key) => {
    setHiddenSections((prev) => ({ ...prev, [key]: false }));
  };

  const toggleSection = (key) => {
    setHiddenSections((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const isHidden = (key) => hiddenSections[key];

  return {
    hideSection,
    showSection,
    toggleSection,
    isHidden,
  };
};

export default useVisibility;
